import { render, staticRenderFns } from "./MainMenuEntity.vue?vue&type=template&id=aa75cae8&"
import script from "./MainMenuEntity.vue?vue&type=script&lang=js&"
export * from "./MainMenuEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports